import { render } from "./ArmoryView.vue?vue&type=template&id=132f764c&scoped=true"
import script from "./ArmoryView.vue?vue&type=script&lang=js"
export * from "./ArmoryView.vue?vue&type=script&lang=js"

import "./ArmoryView.vue?vue&type=style&index=0&id=132f764c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-132f764c"]])

export default __exports__